import type {PerformanceDurationContractEntry} from '../types';

/**
 * Register every performance duration here so the observer can pair its marks.
 */
export const REGISTERED_DURATION_CONTRACT_ENTRIES: readonly PerformanceDurationContractEntry[] =
  [];
